import { render, staticRenderFns } from "./ArenaEquipmentVersionForm.vue?vue&type=template&id=cbd525e8"
import script from "./ArenaEquipmentVersionForm.vue?vue&type=script&lang=js"
export * from "./ArenaEquipmentVersionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports